// Run-time configuration: /config.json names the API (written per environment by deploy/front.ps1), and the
// API's /auth/config says how to sign in. Nothing environment-specific is baked into the build.

export interface PortalConfig {
  apiUrl: string;
  environment: string;
}

export interface AuthConfig {
  enabled: boolean;
  authority: string | null;
  clientId: string | null;
  scope: string | null;
  tenantHeader: string;
  clientUrl: string | null;
  selfServeSignUp?: boolean;
  /** The portal's own sign-in screens (Entra native authentication, through the API); false: Microsoft's sign-in pages. */
  nativeSignIn?: boolean;
  appInsightsConnectionString?: string | null;
}

let config: PortalConfig | null = null;

export async function loadConfig(): Promise<PortalConfig> {
  if (config) return config;
  const response = await fetch("/config.json", { cache: "no-cache" });
  if (!response.ok) throw new Error("The portal's config.json is missing.");
  const loaded = (await response.json()) as PortalConfig;
  config = { ...loaded, apiUrl: loaded.apiUrl.replace(/\/+$/, "") };
  return config;
}

export function getConfig(): PortalConfig {
  if (!config) throw new Error("loadConfig() has not run.");
  return config;
}

export async function loadAuthConfig(apiUrl: string): Promise<AuthConfig> {
  const response = await fetch(`${apiUrl}/api/v1/auth/config`);
  if (!response.ok) throw new Error(`The API at ${apiUrl} did not answer (${response.status}).`);
  return (await response.json()) as AuthConfig;
}
